import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTree24Px = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.521 13.0005H9.521V11.0005H7.521V13.0005Z",
			fill: "#0099FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.521 17.0005H9.521V15.0005H7.521V17.0005Z",
			fill: "#0099FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.521 9.00049H5.521V7.00049H3.521V9.00049Z",
			fill: "#0099FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.521 13.0005H21.521V11.0005H11.521V13.0005Z",
			fill: "#0099FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.521 17.0005H21.521V15.0005H11.521V17.0005Z",
			fill: "#0099FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.521 7.00049V9.00049H21.521V7.00049H7.521Z",
			fill: "#0099FF"
		})
	]
});
export default SvgTree24Px;
